import React from "react";
import { motion } from "framer-motion";

export default function AboutBanner() {
    // Make sure your image is placed here:
    // public/assets/images/backgrounds/about-banner.png
    const publicUrl = process.env.PUBLIC_URL;

    return (
        <section className="w-full h-[70vh] md:h-[85vh] relative overflow-hidden flex items-center justify-center">
            <img
                src={`${publicUrl}/assets/images/backgrounds/contact-banner.png`}
                alt="Nazar Enterprise & Co. - Marine & Industrial Suppliers"
                style={{width: "100%" , maxHeight: "720px"}}
                className="absolute inset-0 w-full h-full object-cover object-center -z-10"
            />

            <div className="absolute inset-0 bg-black/20"></div>

        </section>
    );
}